
import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonButton, IonItem, IonToolbar, IonButtons, IonFooter, IonSpinner, IonInput, IonText, IonModal, IonGrid, IonRow, IonCol, IonLabel, IonIcon, IonHeader, useIonAlert } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { split } from "lodash-es";
import CountryPhoneSelection from '../../../components/CountrySelection/CountryPhoneSelection';
import { arrowBackOutline, chevronDownOutline } from "ionicons/icons";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { useAppSelector, useAppDispatch } from '../../../services/redux/hook';
import { setUser } from "../../../services/redux/slices/user/user";
import { ebioroApi } from "../../../services/api/ebioro/ebioro";
import * as Sentry from '@sentry/react'
import { WalletRecoveryPhoneRequestParameters } from "../../../types/types";
import { parsePhoneNumber } from 'awesome-phonenumber';


const LoginPhone: React.FC<any> = () => {

    const history = useHistory();
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const user = useAppSelector((state) => state.user);
    const initialCountryCallingCode = "1"
    const [countryCallingCode, setcountryCallingCode] = useState(initialCountryCallingCode);
    const [inputLabel, setInputLabel] = useState(`+${countryCallingCode}`)
    const [countryName, setCountryName] = useState('');
    const [isSpinner, setIsSpinner] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState<any>('');
    const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);
    const [countrySelectionModalPage, setCountrySelectionModalPage] = useState(false);
    const [present] = useIonAlert();
    const recoveryServers = useAppSelector((state) => state.recoverServers.recoverServers);

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const sendOTP = async () => {

        setIsSpinner(true);

        const updatedUser = { ...user };

        updatedUser.mobile_number = phoneNumber;
        updatedUser.calling_code = countryCallingCode;
        dispatch(setUser(updatedUser));

        const params: WalletRecoveryPhoneRequestParameters = {
            mobile: phoneNumber
        }

        try {

            const response = await dispatch(ebioroApi.endpoints.recoverWalletByPhone.initiate(params)).unwrap();

            history.push({
                pathname: '/login/phone/verify',
                state: {
                    detail: {
                        id: response.message,
                        jwtToken: response.auth_token

                    }
                }
            })

        } catch (error: any) {

            if (error.data && error.status == 404) {

                presentErrorAlert({ data: error.data.error })

            }

            else {
                presentErrorAlert({ data: t('application.uncaught.ERROR') })
            }

        }

        setIsSpinner(false);

    }

    const checkPhoneNumber = (phoneNumber: any) => {

        // we will start evaluating only if the length of the phone number is >4
        if (phoneNumber.length <= 4) {
            return false
        }

        try {


            const completeNumber = countryCallingCode + phoneNumber;
            const pn = parsePhoneNumber("+" + completeNumber);

            if (pn.valid) {

                let validNumber = pn.number.e164
                setPhoneNumber(validNumber)
                setIsButtonEnabled(true);
            }

            else {

                setIsButtonEnabled(false);

            }



        } catch (error) {
            return false;

        }

    }

    const showCountrySelectionPage = () => {

        setCountrySelectionModalPage(true);
    }

    const closeCountrySelectionPage = () => {
        setCountrySelectionModalPage(false)
    }

    const updateContryCode = (callingCode: string) => {
        setcountryCallingCode(`+${callingCode}`);
        setInputLabel(`+${callingCode}`)
    }

    useEffect(() => {

        const init = async () => {

            try {

                const response = await dispatch(ebioroApi.endpoints.apiRoot.initiate({}, { forceRefetch: true })).unwrap();

                let calling_code = response.calling_code;
                calling_code = split(calling_code, '+')[1];
                updateContryCode(calling_code);


            } catch (error) {

                Sentry.captureException(error);
                presentErrorAlert({ data: t('application.uncaught.ERROR') })
                return;
            }

        }

        init()


    }, []);

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar >
                    <IonButtons slot="start">
                        <IonButton onClick={() => { history.goBack() }} color='primary'>
                            <IonIcon slot="icon-only" icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>

                <AppHeader
                    title={t('registration.phone.HEADER') as string}>
                </AppHeader>


            </IonHeader>
            <IonContent scrollY={false}>

                <IonModal isOpen={countrySelectionModalPage}>

                    <CountryPhoneSelection
                        closeAction={closeCountrySelectionPage}
                        setCallingCode={updateContryCode}
                        setCountryName={setCountryName}
                        phone={true}
                    />

                </IonModal>

                <form style={{ padding: 18 }}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="3">
                                <IonButton 
                                    fill="outline" 
                                    expand="block"
                                    onClick={showCountrySelectionPage}
                                    className="ion-text-center"
                                >
                                    <span>{inputLabel}</span>
                                    <IonIcon icon={chevronDownOutline} slot="end" />
                                </IonButton>
                            </IonCol>
                            <IonCol size="9">
                                <IonInput
                                    label={`${t('registration.phone.HEADER')}`}
                                    className="ion-text-start"
                                    labelPlacement="floating"
                                    mode="md"
                                    fill="outline"
                                    placeholder={t("registration.phone.placeholder") as string}
                                    inputMode='tel'
                                    onIonInput={(e: any) => checkPhoneNumber(e.detail.value)}
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </form>
            </IonContent>
            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        type="submit"
                        color={'primary'}
                        onClick={() => sendOTP()}
                        disabled={!isButtonEnabled}
                        expand="block"
                        id='pageFooterButton'>
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            : t('registration.name.BTN_CONT')}

                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    )
}

export default LoginPhone




